import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getBusinessGroup = (payload) => {
  return axios
    .get(`${URL_ORI}/api/userbusinessgroup`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getTz = (payload) => {
  return axios
    .get(`${URL_ORI}/api/Tz`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateBusinessGroup = (payload) => {
  return axios
    .put(`${URL_ORI}/api/userbusinessgroup`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getNumberSequence = (payload) => {
  return axios
    .get(`${URL_ORI}/api/NumberSequence/Search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createNumberSequence = (payload) => {
  return axios.post(`${URL_ORI}/api/NumberSequence`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const updateNumberSequence = (payload) => {
  return axios.put(`${URL_ORI}/api/NumberSequence`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const getIdNumberSequence = (id) => {
  return axios
    .get(`${URL_ORI}/api/NumberSequence/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteSequence = (payload) => {
  return axios
    .delete(`${URL_ORI}/api/NumberSequence`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const uploadImage = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios
    .post(`${URL_ORI}/api/UserBusinessGroup/AddImage`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};


export const deleteImage = (payload) => {
  return axios.post(`${URL_ORI}/api/UserBusinessGroup/DeleteImage`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

